import * as Constants from '../../constants';

import * as IntegrationHandlers from './handlers';

export default [
  {
    actionType: Constants.AudioPlayer.AudioPlayerActions.ENDED,
    handler: IntegrationHandlers.trackEnded,
    concur: 'takeOnly',
  },
  {
    actionType: Constants.Integrations.ActionTypes.TRACK_STARTED_FROM_SOURCE,
    handler: IntegrationHandlers.trackStartedfromSource,
    concur: 'takeEvery',
  },
  {
    actionType: Constants.Integrations.ActionTypes.SOURCE_STARTED,
    handler: IntegrationHandlers.sourceStarted,
    concur: 'takeEvery',
  },
  {
    actionType: [
      Constants.Api.ApiActions.CATALOG_ANNOTATE_OBJECTS_SUCCESS,
      Constants.Api.ApiActions.AESOP_ANNOTATE_OBJECTS_SUCCESS,
    ],
    handler: IntegrationHandlers.garbageCollect,
    concur: 'takeOnly',
  },
  {
    actionType: Constants.Integrations.ActionTypes.SIGN_UP_CLICKED,
    handler: IntegrationHandlers.signUpClicked,
    concur: 'takeEvery',
  },
  {
    actionType: Constants.Integrations.ActionTypes.LOG_IN_CLICKED,
    handler: IntegrationHandlers.logInClicked,
    concur: 'takeEvery',
  },
  {
    actionType: Constants.Integrations.ActionTypes.APP_STORE_CLICKED,
    handler: IntegrationHandlers.appStoreClicked,
    concur: 'takeEvery',
  },
  {
    actionType: Constants.Integrations.ActionTypes.VIEW_PLANS_CLICKED,
    handler: IntegrationHandlers.viewPlansClicked,
    concur: 'takeEvery',
  },
  {
    actionType: Constants.Payments.Actions.UPGRADE_CTA_CLICK,
    handler: IntegrationHandlers.upgradeCtaClicked,
    concur: 'takeEvery',
  },
  {
    actionType: Constants.Payments.Actions.UPGRADE_DISCOUNT_PLAN_LINK_CLICKED,
    handler: IntegrationHandlers.upgradeDiscountPlanLinkClicked,
    concur: 'takeEvery',
  },
];
